/** user-center 下 userManage 相关接口（消息、用户权限等） */
export const URL_PREFIX = '/user-center/userManage'
/** user-center 网关根路径（如 `/firm/*` 等非 userManage 子路径） */
export const URL_USER_CENTER_PREFIX = '/user-center'
/** nem-center 网关根路径（如省市静态数据等） */
export const URL_NEM_CENTER_PREFIX = '/nem-center'
